import { Button, ButtonProps, Palette, PaletteColor, alpha } from '@mui/material';
import { styled } from '@mui/material/styles';

interface PrimaryButtonProps extends ButtonProps {
  palette_color?: keyof Palette;
}

/**
 * Standard contained button to be reused across app.
 * @param {keyof Palette | undefined} palette_color Optionally specify a different theme color to use for the button, defaults to teal.
 * @returns {JSX.Element}
 */
const PrimaryButton = styled(Button, {
  shouldForwardProp: (prop: string) => prop !== 'palette_color'
})<PrimaryButtonProps>(({ theme, palette_color = 'teal' }) => ({
  backgroundColor: (
    theme.palette[
      theme.palette[palette_color] ? (palette_color as keyof Palette) : 'primary'
    ] as PaletteColor
  ).dark,
  color: theme.palette.teal ? theme.palette.teal.contrastText : theme.palette.primary.contrastText,
  borderRadius: 6,
  minWidth: 100,
  fontSize: '0.9rem',
  fontWeight: theme.typography.fontWeightMedium,
  paddingTop: 6,
  paddingBottom: 6,
  paddingLeft: 12,
  paddingRight: 12,
  textTransform: 'none',
  boxShadow: theme.shadows[1],
  '&:hover': {
    backgroundColor: (
      theme.palette[
        theme.palette[palette_color] ? (palette_color as keyof Palette) : 'primary'
      ] as PaletteColor
    ).main
  },
  '&.Mui-disabled': {
    backgroundColor: alpha(theme.palette.secondary.main, 0.2),
    color: alpha(theme.palette.secondary.dark, 0.4),
    boxShadow: 'none'
  }
}));

export default PrimaryButton;
